import { useRef } from "react";
import { useQuestionizerStore } from "../types/state.ts";
import Toggle from "./toggle.tsx";

export default function InputGroupToggle (props: {id: number, icon:string, icon_active?:string, label: string, info_title: string,info_text: string, deactivate_ids?:Array<number>, onBlur?: ()=>void}){
  const updateValidation = useQuestionizerStore((state) => state.updateValidation);
  const active_groups = useQuestionizerStore((state) => state.active_groups);
  const active_group = useQuestionizerStore((state) => state.active_group);
  const toggleGroup = useQuestionizerStore((state) => state.toggleGroup);
  const toggleGewerk = useQuestionizerStore((state) => state.toggleGewerk);
  const active_items_per_group = useQuestionizerStore((state) => state.active_items_per_group);

  const is_active = props.id == active_group;
  //const is_active = active_groups[props.id];

  return <Toggle 
      type="button"
      id={props.id.toString()} 
      count={active_items_per_group ? active_items_per_group[props.id] : undefined} 
      label={props.label} info_title={props.info_title} 
      info_text={props.info_text} icon={props.icon} 
      icon_active={props.icon_active} 
      value={is_active} 
      onChange={(value)=>{
        // USE THIS IF ONLY ONE GROUP SHOULD BE ACTIVE AT THE SAME TIME
        if (props.deactivate_ids !== undefined){
          props.deactivate_ids.forEach((id)=>{
            toggleGewerk(id, false);
          });
        }
        toggleGroup(props.id, value);
        updateValidation();
        //document.querySelector(".group-"+props.id)?.scrollIntoView({ block: 'start',  behavior: 'smooth' });
    }}
    onBlur={props.onBlur}
    />
}
